// Generated by bin/generate-feature-toggle-names.mjs. Do not edit manually.
//
// Canonical list of every feature-toggle name the UI references, extracted from
// useFeatureToggle('x'), <Feature name="x">, and sidebar feature: entries. Used
// to front-load toggle state for the current user in a single request at app
// startup (see AppLayout), so useFeatureToggle reads synchronously with no
// false→true flicker (TRK-4860). Regenerate with `bun run codegen`.
export const FEATURE_TOGGLE_NAMES = [
  `action-center`,
  `ai-agent-config-route`,
  `ai-agent-configuration-route-v1`,
  `ai-agent-enabled`,
  `ai-agent-only`,
  `ai-agent-only-notifications`,
  `attribution`,
  `attribution-v2`,
  `availability-settings`,
  `bulk-sms`,
  `click-to-call`,
  `contact-active-leads`,
  `contact-drawer-customization`,
  `dark-mode`,
  `dni`,
  `facebook-leads-personal-token`,
  `global-search`,
  `grouped-navigation`,
  `hygiene`,
  `inbox-email`,
  `incoming-call-alerts`,
  `insurances`,
  `integrated-mode`,
  `merge-contacts`,
  `needs-action-date`,
  `new-contact-drawer`,
  `notifications`,
  `paperwork`,
  `pms-comm-log`,
  `related-contacts-prototype`,
  `revenue-dashboard`,
  `scheduled-sms`,
  `scheduling`,
  `staff-dashboard-v2`,
  `staff-v2`,
  `TRK-2569`,
  `TRK-2637`,
  `TRK-3672`,
  `workflow-matches`,
  `workflows-builder`,
  `workspace-integrations`,
] as const
